import { Component, OnDestroy, OnInit,  ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { AppComponent } from './app.component';
import { AppMainComponent } from './app.main.component';
import { Subscription } from 'rxjs';
import { ChangePasswordComponent } from './pages/user/change-password/change-password.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent implements OnInit, OnDestroy {

    subscription: Subscription;

    items: any[] = [];
    filteredItems: any[] = [];

    firm: any;

    constructor(public app: AppComponent, public appMain: AppMainComponent, private router: Router, public viewContainerRef: ViewContainerRef, private componentFactoryResolver: ComponentFactoryResolver) { }
    ngOnInit(): void {
        this.firm = sessionStorage.getItem('firm');


        const appComponent = this.router.config.find(f => f.component.name == 'AppMainComponent');
        if(appComponent) {
            const routes = appComponent.children.filter(f => f.data && f.data.useSearch);
            routes.forEach(r =>  this.items.push({ name: r.data.title, value: r.path}));
        }
       
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    onSearch(event) {
        this.filteredItems = [];
        this.items.forEach(v => {
            if (v.name.toLocaleUpperCase('tr-TR').indexOf(event.query.toLocaleUpperCase('tr-TR')) === 0)  this.filteredItems.push(v);
        });
        return this.filteredItems;
    }

    onHandleSearchSelect(event) {
        this.router.navigate([event.value]);
    }

    showChangePasswordDialog() {
        let factory = this.componentFactoryResolver.resolveComponentFactory(ChangePasswordComponent);
        let componentRef = this.viewContainerRef.createComponent(factory);
        componentRef.instance.display = true;
      }



}
